import React, { lazy, Suspense } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import LoadingSpinner from '../../Common/LoadingSpinner';
import styles from './styles.module.scss';

const About = lazy(() => import('../../../Contents/About'));

export default function AboutDYCModal({ isOpen, onToggle }) {
    return (
        <Modal
            isOpen={isOpen}
            toggle={onToggle}
            className={styles.aboutDYCModal}>
            <ModalHeader toggle={onToggle}>About</ModalHeader>
            <ModalBody>
                <Suspense fallback={<div className="text-center p-5"><LoadingSpinner /></div>}>
                    <About isDonateYourCard={true} />
                </Suspense>
            </ModalBody>
        </Modal>)
}